export const VOLT_REDIRECT_CALLBACK = 'voltRedirectCallback';
export const MOBILE_REDIRECT_CALLBACK = 'mobileRedirectCallback';

export const BRIDGE_CALLBACKS = [
  VOLT_REDIRECT_CALLBACK,
  MOBILE_REDIRECT_CALLBACK,
] as const;
